const handleZero = (index, startFromZero) =>
  startFromZero ? index : index + 1;

const getAnswerValue = ({ value, label }, index, startFromZero) =>
  value || label || handleZero(index, startFromZero);

const getAnswerLabel = ({ label, value, type }, index, startFromZero) =>
  (label || value || type || handleZero(index, startFromZero)).toString();

const answerToDropdownOptions = (answer, index, startFromZero = false) => ({
  label: getAnswerLabel(answer, index, startFromZero),
  value: getAnswerValue(answer, index, startFromZero),
});

export default answerToDropdownOptions;
